<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  showBack: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['back'])
</script>

<template>
  <header class="modal-header">
    <div class="modal-header__row">
      <v-btn-icon
        v-if="showBack"
        icon="mdi-arrow-left"
        :aria-label="$t('COMMON.BUTTON.BACK')"
        @click="emit('back')"
      />
      <h2 class="modal-header__title">
        {{ title }}
      </h2>
      <v-spacer />
    </div>
    <p v-if="subtitle" class="modal-header__subtitle">
      {{ subtitle }}
    </p>
  </header>
</template>

<style scoped>
.modal-header {
  padding: 24px;
}

.modal-header__row {
  align-items: center;
  display: flex;
  gap: 10px;
}

.modal-header__title {
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  min-width: 0;
}

.modal-header__subtitle {
  color: rgba(var(--v-theme-on-surface), 0.68);
  font-size: 1rem;
  line-height: 1.35;
  margin: 8px 0 0;
}

@media (max-width: 599.98px) {
  .modal-header {
    padding: 16px;
  }
}
</style>
